import 'jquery';

/**
 * our logger
 */
export let plenigoLog = {
  /**
   * stores last title to prevent logging in a loop
   */
  _lastTitle: '',
  /**
   *
   * @param {string} title
   * @param {object} data
   * @private
   */
  info: function (title, data) {
    this._log('info', title, data);
  },
  /**
   *
   * @param {string} title
   * @param {object} data
   */
  error: function (title, data) {
    this._log('error', title, data);
  },
  /**
   * send log message to server
   * @param {string} level
   * @param {string} title
   * @param {object} data
   * @private
   */
  _log: function (level, title, data) {
    // our sessionId should be rendered as data attribute to each body tag
    let sessionId = $('body').data('session-id') || null;

    // without sessionID we can't recognize who is logging here
    if (sessionId === null) {
      return;
    }

    // we dont't want to get too many log entries
    if (this._lastTitle === 'title') {
      return;
    }

    // set our lastTitle with actual title to be able to campare it next time
    this._lastTitle = title;

    $.ajax({
      // Method ony accepts post
      type: 'POST',
      //our logging url. @Todo: this should be a setting
      url: '/de/default/log/' + sessionId,
      dataType: 'json',
      async: true,
      //json object to sent to the authentication url
      data: JSON.stringify({
        level: level,
        title: title,
        data: data,
      }),
      success: function () {
        console.log('got it');
      },
    });
  },
};